import React from 'react';
import AiSparkleIcon from './AiSparkleIcon';

function Textarea({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  rows = 4,
  hint,
  error,
  action,
}) {
  const hasAction = Boolean(action);
  const isAiIconAction = hasAction && action.iconOnly;

  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <textarea
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          rows={rows}
          className={`field-input resize-y min-h-[100px] ${hasAction ? 'pb-14 pr-14' : ''} ${
            error ? 'field-input-error' : ''
          }`}
        />
        {hasAction && (
          <div className="absolute bottom-4 right-4">
            {isAiIconAction ? (
              <button
                type="button"
                onClick={action.onClick}
                disabled={action.disabled || action.loading}
                aria-label={action.ariaLabel || 'Melhorar com IA'}
                title={action.title || action.ariaLabel || 'Melhorar com IA'}
                className={`btn-ai-refine ${action.loading ? 'btn-ai-refine-loading' : ''}`}
              >
                {action.loading ? (
                  <span className="h-3.5 w-3.5 rounded-full border-2 border-violet-300 border-t-violet-600 animate-spin" />
                ) : (
                  <AiSparkleIcon className="h-4 w-4" />
                )}
              </button>
            ) : (
              <button
                type="button"
                onClick={action.onClick}
                disabled={action.disabled || action.loading}
                className="text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white text-content-muted hover:text-forge-600 hover:border-forge-300 disabled:opacity-40 disabled:cursor-not-allowed transition-colors shadow-sm"
              >
                {action.loading ? action.loadingLabel || 'Melhorando...' : action.label}
              </button>
            )}
          </div>
        )}
      </div>
      {hint && !error && !action?.error && (
        <p className="mt-1.5 text-xs text-content-muted">{hint}</p>
      )}
      {(error || action?.error) && (
        <p className="mt-1.5 text-xs text-red-600">{error || action.error}</p>
      )}
    </div>
  );
}

export default Textarea;
